import axios from "axios";

import endPoints from "../config/endPoints.config";

// Base URL for all apis
export const API = axios.create({ baseURL: endPoints.baseApiUrl });

export const GetSingleClientByDomain = (domain: any) =>
  API.get(`/api/client/view-by-domain/${domain}`);
